import { useMemo } from "react";
import { useMessagerieStore } from "@store/messagerieStore";
import { navigateTo } from "context/navigation.service";

export default function RecentMessagesWidget() {
  const discussions = useMessagerieStore((s) => s.discussions);
  const recentDiscussions = useMemo(() => discussions.slice(0, 4), [discussions]);

  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <div className="flex flex-row justify-between items-center mb-1">
        <div className="font-semibold text-black">Messages récents</div>
        <button
          onClick={() => navigateTo({ route: "/messagerie" })}
          className="text-h3 text-neutral-400 hover:text-neutral-600"
        >
          Voir tout
        </button>
      </div>
      {recentDiscussions.length === 0 && (
        <div className="text-h3 text-neutral-300 py-2">Aucun message</div>
      )}
      {recentDiscussions.map((disc) => (
        <div
          key={disc.id}
          className="flex flex-row items-start p-2 gap-3 cursor-pointer hover:bg-neutral-50 rounded-lg"
          onClick={() => navigateTo({ route: "/messagerie" })}
        >
          <div className="flex flex-col flex-1 min-w-0">
            <div className="text-h2 font-medium text-black">{disc.name}</div>
            <div className="text-h3 text-neutral-400 truncate">{disc.lastMessage || ""}</div>
          </div>
          <div className="flex flex-col items-end gap-1 flex-shrink-0">
            <div className="text-h4 text-neutral-400">{disc.lastMessageTime || ""}</div>
            {disc.unread && <div className="w-2 h-2 rounded-full bg-blue-500" />}
          </div>
        </div>
      ))}
    </div>
  );
}
